import type { FC } from 'react';
import { Route, Routes } from 'react-router';
import PoliciesPage from './_pages/PoliciesPage';

export const PolicyRoutes: FC = () => {
  return (
    <Routes>
      <Route index element={<PoliciesPage />} />
    </Routes>
  );
};
